import React from "react";
import { tourviewdetail } from "../../../../../services/superadmin";
import { crmtourviewdetail } from "../../../../../services/cityregionaladmin";
import { Reftourdetail } from "../../../../../services/referee";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { scheadtourviewdetail } from "../../../../../services/schoolhead";
import dotracking from "../../../../trackinglogs";
import trackobj from "../../../../trackingpages.json";
import { coachtourviewdetail } from "../../../../../services/coach";
import {
  leaderboardsportscreate,
  leaderboardsportsdelete,
  leaderboardsportslist,
  leaderboardsportstruncate,
  leadercreate,
  leaderupdate,
  sportwiseleadercreate,
  sportwiseleaderdelete,
  sportwiseleaderdetail,
  sportwiseleaderlist,
  sportwiseleaderupdate,
} from "../../../../../services/common";
import moment from "moment";
import Swal from "sweetalert2";
import Select from "react-select";
import { sportslist } from "../../../../../services/master";

export const Leaderboard = () => {
  const { id } = useParams();
  const [filterProduct, setFilterProduct] = useState([]);

  const [hname, setHName] = useState("");
  const [csport, setCSport] = useState("");
  const [tsport, setTSport] = useState("");
  const [bsport, setBsport] = useState("");
  const [fsport, setFSport] = useState("");
  const [asport, setASport] = useState("");
  const [ttsport, setTTSport] = useState("");
  const [bksport, setBKSport] = useState("");
  const [vsport, setVsport] = useState("");
  const [twsport, setTWsport] = useState("");
  const [lsport, setLSport] = useState("");

  const [teamid, setTeamId] = useState("");
  const [slist, setSList] = useState([]);
  const [scat, setSCat] = useState([]);

  function highedit(hid, hdata) {
    // if (filterProduct.length > 0) {
    //   const data = filterProduct.find((item) => item.id == tid);
    //   if (data !== undefined) {
    //     setShow(true);
    //     setHName(data.team_house_name);
    //     if (data.cricket !== null) {
    //       setCSport(data.cricket);
    //     }
    //     if (data.tennis !== null) {
    //       setTSport(data.tennis);
    //     }
    //     if (data.badminton !== null) {
    //       setBsport(data.badminton);
    //     }
    //     if (data.football !== null) {
    //       setFSport(data.football);
    //     }
    //     if (data.athletics !== null) {
    //       setASport(data.athletics);
    //     }
    //     if (data.basket_ball !== null) {
    //       setBKSport(data.basket_ball);
    //     }
    //     if (data.table_tennis !== null) {
    //       setTTSport(data.table_tennis);
    //     }
    //     if (data.volleyball !== null) {
    //       setVsport(data.volleyball);
    //     }
    //     if (data.tug_of_war !== null) {
    //       setTWsport(data.tug_of_war);
    //     }
    //     if (data.lagori !== null) {
    //       setLSport(data.lagori);
    //     }

    //     setTeamId(tid);
    //   }
    // }
    dotracking(
      "edit icon in leaderboard list for " +
        hdata.team_name +
        " (" +
        hid +
        ") $$ " +
        trackobj.leadheading
    );

    sportwiseleaderdetail(hid).then((res) => {
      if (res.status === true) {
        setTeamId(res.data.team_id);
        setHName(res.data.team_name);
        const pointsMap = {};
        res.data.points.forEach((pt) => {
          pointsMap[pt.sports_id] = pt.points;
        });

        const sdata = sportsOptions.map((item) => ({
          ...item,
          points: pointsMap[item.sports_id] || 0,
        }));

        setSportsOptions(sdata);
        setShow(true);
      }
    });
  }

  function highdelete(hid, hdata) {
    Swal.fire({
      text: "Are you sure want to Delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        dotracking(
          "delete icon in leaderboard list for " +
            hdata.team_name +
            " (" +
            hid +
            ") $$ " +
            trackobj.leadheading
        );
        // leaderdelete(localStorage.getItem("UID"), hid).then((response) => {
        //   if (response.status === true) {
        //     listall();
        //     toast.success(response.message);
        //   }
        // });
        sportwiseleaderdelete(hid).then((res) => {
          if (res.status === true) {
            listall();
            toast.success(res.message);
          }
        });
      }
    });
  }

  const [tname, setTName] = useState("");
  const [edate, setEDate] = useState("");

  const [show, setShow] = useState(false);
  const [sportsOptions, setSportsOptions] = useState([]);

  const updateSportPoints = (index, field, value) => {
    const updated = [...sportsOptions];
    updated[index][field] = value || 0;
    setSportsOptions(updated);
  };
  function handleShow() {
    setErrorMsg("");
    setHName("");
    setTeamId("");
    const enrichedSports = sportsOptions.map((sport) => ({
      ...sport,
      points: "",
    }));

    setSportsOptions(enrichedSports);
    setShow(true);
  }
  function handleclose() {
    setShow(false);
  }

  function submitpoints(e) {
    e.preventDefault();
    if (!hname) {
      setErrorMsg("Team House Name id required.");
      return;
    }
    if (teamid != "") {
      const payload = {
        tournament_id: id,
        team_id: teamid,
        team_name: hname,
        points: sportsOptions.map((item) => ({
          sports_id: parseInt(item.sports_id),
          points: parseInt(item.points),
        })),
      };
      dotracking(
        "update button in add leaderboard for " +
          tname +
          " (" +
          id +
          ") tournament $$ " +
          trackobj.leadheading
      );
      sportwiseleaderupdate(payload).then((response) => {
        if (response.status === true) {
          handleclose();
          listall();
          toast.success(response.message);
        } else {
          setErrorMsg(response.message);
        }
      });
    } else {
      const payload = {
        tournament_id: id,
        team_name: hname,
        points: sportsOptions.map((item) => ({
          sports_id: parseInt(item.sports_id),
          points: parseInt(item.points),
        })),
      };

      dotracking(
        "add button in add leaderboard for " +
          tname +
          " (" +
          id +
          ") tournament $$ " +
          trackobj.leadheading
      );
      sportwiseleadercreate(payload).then((response) => {
        if (response.status === true) {
          handleclose();
          listall();
          toast.success(response.message);
        } else {
          setErrorMsg(response.message);
        }
      });
    }
  }
  // function handleShow() {
  //   setErrorMsg("");
  //   setHName("");
  //   setCSport("");
  //   setTSport("");
  //   setBsport("");
  //   setFSport("");
  //   setASport("");
  //   setBKSport("");
  //   setTTSport("");
  //   setVsport("");
  //   setTWsport("");
  //   setLSport("");
  //   setShow(true);
  // }

  // function handleclose() {
  //   setShow(false);
  //   setErrorMsg("");
  //   setHName("");
  //   setCSport("");
  //   setTSport("");
  //   setBsport("");
  //   setVsport("");
  //   setTWsport("");
  //   setFSport("");
  //   setASport("");
  //   setBKSport("");
  //   setTTSport("");
  //   setLSport("");
  // }

  const navigate = useNavigate();
  function backlist() {
    dotracking(
      "back button in leaderboard for " +
        tname +
        " (" +
        id +
        ") tournament $$ " +
        trackobj.tourlistheading
    );
    if (localStorage.getItem("Role") === "1") {
      navigate("/superadmin/tournamentlist");
    } else if (localStorage.getItem("Role") === "3") {
      navigate("/cityregional/tournamentlist");
    } else if (localStorage.getItem("Role") === "4") {
      navigate("/schoolhead/tournamentlist");
    } else if (localStorage.getItem("Role") === "5") {
      navigate("/referee/tournamentlist");
    } else if (localStorage.getItem("Role") === "7") {
      navigate("/coach/tournamentlist");
    }
  }

  useEffect(() => {
    if (localStorage.getItem("Role") === "1") {
      tourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          const endDate = new Date(response.data.tournament.end_date);
          endDate.setDate(endDate.getDate() + 10);
          setEDate(moment(endDate).format("yyyy-MM-DD"));
          setTName(response.data.tournament.meet_name);
        }
      });
    } else if (localStorage.getItem("Role") === "3") {
      crmtourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);

          const endDate = new Date(response.data.tournament.end_date);
          endDate.setDate(endDate.getDate() + 10);
          setEDate(moment(endDate).format("yyyy-MM-DD"));
        }
      });
    } else if (localStorage.getItem("Role") === "4") {
      scheadtourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
          const endDate = new Date(response.data.tournament.end_date);
          endDate.setDate(endDate.getDate() + 10);
          setEDate(moment(endDate).format("yyyy-MM-DD"));
        }
      });
    } else if (localStorage.getItem("Role") === "5") {
      Reftourdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
          const endDate = new Date(response.data.tournament.end_date);
          endDate.setDate(endDate.getDate() + 10);
          setEDate(moment(endDate).format("yyyy-MM-DD"));
        }
      });
    } else if (localStorage.getItem("Role") === "7") {
      coachtourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
          const endDate = new Date(response.data.tournament.end_date);
          endDate.setDate(endDate.getDate() + 10);
          setEDate(moment(endDate).format("yyyy-MM-DD"));
        }
      });
    }

    sportslist().then((response) => {
      if (response.status === true) {
        let arr1 = [];
        if (response.data.length !== 0) {
          for (let i = 0; i < response.data.length; i++) {
            arr1.push({
              value: response.data[i].sports_cat_uid,
              label: response.data[i].sports_category,
            });
          }
        }
        setSList(arr1);
      }
    });
    listall();
  }, []);

  const [errorMsg, setErrorMsg] = useState("");
  function submithigh() {
    setErrorMsg("");
    if (hname !== "") {
      let ctot = 0;
      const temp = new FormData();
      temp.append("tournament_meet_id", id);
      temp.append("admin_id", localStorage.getItem("UID"));
      temp.append("team_house_name", hname);

      if (csport === "") {
        temp.append("cricket", 0);
      } else {
        ctot = ctot + parseInt(csport);
        temp.append("cricket", csport);
      }

      if (tsport === "") {
        temp.append("tennis", 0);
      } else {
        ctot = ctot + parseInt(tsport);
        temp.append("tennis", tsport);
      }

      if (bsport === "") {
        temp.append("badminton", 0);
      } else {
        ctot = ctot + parseInt(bsport);
        temp.append("badminton", bsport);
      }

      if (fsport === "") {
        temp.append("football", 0);
      } else {
        ctot = ctot + parseInt(fsport);
        temp.append("football", fsport);
      }

      if (asport === "") {
        temp.append("athletics", 0);
      } else {
        ctot = ctot + parseInt(asport);
        temp.append("athletics", asport);
      }

      if (ttsport === "") {
        temp.append("table_tennis", 0);
      } else {
        ctot = ctot + parseInt(ttsport);
        temp.append("table_tennis", ttsport);
      }
      if (bksport === "") {
        temp.append("basket_ball", 0);
      } else {
        ctot = ctot + parseInt(bksport);
        temp.append("basket_ball", bksport);
      }
      if (vsport === "") {
        temp.append("volleyball", 0);
      } else {
        ctot = ctot + parseInt(vsport);
        temp.append("volleyball", vsport);
      }
      if (twsport === "") {
        temp.append("tug_of_war", 0);
      } else {
        ctot = ctot + parseInt(twsport);
        temp.append("tug_of_war", twsport);
      }

      if (lsport === "") {
        temp.append("lagori", 0);
      } else {
        ctot = ctot + parseInt(lsport);
        temp.append("lagori", lsport);
      }
      // parseInt(tsport) +

      temp.append("total", ctot);
      if (teamid == "") {
        temp.append("leaderboard_end_date", edate);
        dotracking(
          "add button in add leaderboard for " +
            tname +
            " (" +
            id +
            ") tournament $$ " +
            trackobj.leadheading
        );
        leadercreate(temp).then((response) => {
          if (response.status === true) {
            handleclose();
            listall();
            toast.success(response.message);
          } else {
            setErrorMsg(response.message);
          }
        });
      } else {
        temp.append("leader_board_id", teamid);
        dotracking(
          "update button in add leaderboard for " +
            tname +
            " (" +
            id +
            ") tournament $$ " +
            trackobj.leadheading
        );
        leaderupdate(temp).then((response) => {
          if (response.status === true) {
            handleclose();
            listall();
            toast.success(response.message);
          } else {
            setErrorMsg(response.message);
          }
        });
      }
    } else {
      setErrorMsg("Please Enter Team House Name");
    }
  }

  function listall() {
    // leaderlist(id).then((response) => {
    //   if (response.status === true) {
    //     setFilterProduct(response.data.leaderboard_list);
    //   }
    // });
    const temp1 = new FormData();
    temp1.append("tournament_id", id);
    sportwiseleaderlist(temp1).then((res1) => {
      if (res1.status === true) {
        const sportsData = res1.data;
        const teamMap = {};

        sportsData.forEach((entry) => {
          const { team_id, team_name, sports_id, points } = entry;
          if (!teamMap[team_id]) {
            teamMap[team_id] = {
              team_id,
              team_name,
              total: 0,
            };
          }

          teamMap[team_id][sports_id] = points;
          teamMap[team_id].total += points;
        });

        const formattedTeams = Object.values(teamMap); // Array of row objects
        setFilterProduct(formattedTeams);
      }
    });

    setSportsOptions([]);
    const temp = new FormData();
    temp.append("tournament_id", id);
    leaderboardsportslist(temp).then((res2) => {
      if (res2.status === true) {
        setSportsOptions(res2.data);
      }
    });
  }

  const handleCricket = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setCSport(e.target.value);
    }
  };

  const handleTennis = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setTSport(e.target.value);
    }
  };

  const handleBadminton = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setBsport(e.target.value);
    }
  };

  const handleFootball = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setFSport(e.target.value);
    }
  };

  const handleVolley = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setVsport(e.target.value);
    }
  };

  const handleTugofwar = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setTWsport(e.target.value);
    }
  };
  const handleAthletics = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setASport(e.target.value);
    }
  };

  const handleBasketball = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setBKSport(e.target.value);
    }
  };

  const handleTable = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setTTSport(e.target.value);
    }
  };
  const handleLagori = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setLSport(e.target.value);
    }
  };
  const [show1, setShow1] = useState(false);
  const submitsport = async () => {
    if (!scat || scat.length === 0) {
      setErrorMsg("Please Select Sport");
      return;
    }

    const payload = {
      sports: scat.map((item) => ({
        tournament_id: id,
        sports_id: parseInt(item.value),
        sports_name: item.label,
      })),
    };

    leaderboardsportscreate(payload).then((res) => {
      if (res.status === true) {
        setShow1(false);
        listall();
        toast.success(res.message);
      }
    });
  };

  function deleteItem(hid, hdata) {
    dotracking(
      "delete icon in edit sports in leaderboard for " +
        hdata.sports_name +
        " (" +
        hid +
        ") $$ " +
        trackobj.leadheading
    );

    const isLastItem = sportsOptions.length == 1;
    if (isLastItem) {
      leaderboardsportstruncate(hid).then((truncateRes) => {
        if (truncateRes.status === true) {
          listall([]);
          toast.success(truncateRes.message);
        } else {
          toast.error(truncateRes.message);
        }
      });
    } else {
      leaderboardsportsdelete(hid).then((res) => {
        if (res.status === true) {
          listall([]);
          toast.success(res.message);
        }
      });
    }
  }

  function handleShow1() {
    setErrorMsg("");
    setSCat([]);
    setShow1(true);
  }

  function handlesport(e) {
    if (e !== null) {
      setSCat(e);
    }
  }

  return (
    <div className="side-app">
      <div className="page-header">
        <div className="breadcrumb">
          <h4 className="mb-0">Leaderboard</h4>
        </div>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Tournament</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Leaderboard
          </li>
        </ol>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card mt-0">
            <div className="card-body">
              <div className="row mb-3">
                <div className="col-md-6">
                  <div className="text-left">
                    <h3>{tname}</h3>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="text-right">
                    {(localStorage.getItem("Role") === "1" ||
                      localStorage.getItem("Role") === "7") && (
                      <>
                        <a
                          className="btn btn-warning me-2"
                          onClick={handleShow1}
                        >
                          <i className="fe fe-plus"></i> Add Sports
                        </a>
                        <a
                          className="btn btn-success me-2"
                          onClick={handleShow}
                        >
                          <i className="fe fe-plus"></i> Add Leaderboard
                        </a>
                      </>
                    )}

                    <a className="btn btn-gray" onClick={backlist}>
                      <i className="fe fe-corner-up-left"></i> Back
                    </a>
                  </div>
                </div>
              </div>

              <Modal show={show1} size="lg">
                <Modal.Header>
                  <h4>Add Sports</h4>
                </Modal.Header>
                <Modal.Body>
                  <Row className="row-sm mx-0">
                    <Col lg={12} md={12}>
                      <label className="form-label">
                        Select Sports <span className="errortext"> *</span>
                      </label>
                      <Select
                        className="dropdown"
                        placeholder="Select Sports"
                        value={scat}
                        options={slist}
                        onChange={handlesport}
                        isSearchable
                        isMulti
                      />
                    </Col>
                    {sportsOptions.length > 0 && (
                      <div className="details-group refereebox deletereferee mt-5">
                        <div className="row">
                          {sportsOptions.map((data, i) => (
                            <div className="col-md-3 align-self-center" key={i}>
                              <div className="form-group">
                                <h4 className="mb-1">{data.sports_name}</h4>
                                <a
                                  className="deleterefer"
                                  onClick={() =>
                                    deleteItem(data.id, data.sports_name)
                                  }
                                >
                                  <i className="fa fa-close"></i>
                                </a>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </Row>
                  {errorMsg !== "" && (
                    <span className="errortext">{errorMsg}</span>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <a className="btn btn-danger" onClick={() => setShow1(false)}>
                    Close
                  </a>
                  <a className="btn btn-success" onClick={submitsport}>
                    Add
                  </a>
                </Modal.Footer>
              </Modal>

              <Modal show={show} size="lg" onHide={handleclose}>
                <Modal.Header>
                  {teamid == "" && <h4> Add Leaderboard</h4>}
                  {teamid != "" && <h4> Leaderboard Details</h4>}
                </Modal.Header>
                <Modal.Body>
                  <Row className="row-sm mx-0">
                    <Col lg={6} md={6}>
                      <div className="form-group">
                        <label className="mb-2">
                          Team House Name <span className="errortext"> *</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Team House Name"
                          className="form-control"
                          value={hname}
                          onChange={(e) => setHName(e.target.value)}
                        />
                      </div>
                    </Col>
                    {sportsOptions.map((item, index) => (
                      <Col lg={6} md={6} key={index}>
                        <div className="form-group">
                          <label className="mb-1">
                            {item.sports_name} Points{" "}
                            <span className="errortext">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder={`Enter ${item.sports_name} Points`}
                            value={item.points}
                            min="0"
                            onChange={(e) =>
                              updateSportPoints(index, "points", e.target.value)
                            }
                          />
                        </div>
                      </Col>
                    ))}
                    {/* <Col md={12}>
                      <div className="d-flex justify-content-between align-items-center mt-3 mb-2">
                        <label className="mb-0">
                          Sports & Points <span className="errortext">*</span>
                        </label>
                        <button
                          className="btn btn-sm btn-success"
                          onClick={addSportPoints}
                        >
                          <i className="fa fa-plus"></i> Add
                        </button>
                      </div>

                      {pointslist.map((item, index) => (
                        <Row key={index} className="align-items-center mb-2">
                          <Col md={6}>
                            <select
                              className="form-control"
                              value={item.sport}
                              onChange={(e) =>
                                updateSportPoints(
                                  index,
                                  "sport",
                                  e.target.value
                                )
                              }
                            >
                              <option value="">Select Sport</option>
                              {sportsOptions.map((sport, i) => (
                                <option key={i} value={sport.sports_id}>
                                  {sport.sports_name}
                                </option>
                              ))}
                            </select>
                          </Col>
                          <Col md={4}>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Points"
                              value={item.points}
                              onChange={(e) =>
                                updateSportPoints(
                                  index,
                                  "points",
                                  e.target.value
                                )
                              }
                            />
                          </Col>
                          <Col md={2}>
                            {pointslist.length > 1 && (
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => removeSportPoints(index)}
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            )}
                          </Col>
                        </Row>
                      ))}

                      {teamid !== 0 && (
                        <div className="details-group refereebox deletereferee mt-5">
                          <div className="row">
                            {filterProduct.map((data, i) => {
                              return (
                                <div
                                  className="col-md-6 align-self-center"
                                  key={i}
                                >
                                  <div className="form-group">
                                    <h4 className="mb-1">
                                      {data.sports_name}{" - "} { data.points} Points
                                    </h4>
                                    <a
                                      className="deleterefer"
                                      onClick={() =>
                                        deletesport(
                                          data.sports_id,
                                          data.sports_name
                                        )
                                      }
                                    >
                                      <i className="fa fa-close"></i>
                                    </a>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )} 
                    </Col> */}
                  </Row>
                  {errorMsg !== "" && (
                    <span className="errortext">{errorMsg}</span>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <a className="btn btn-danger" onClick={handleclose}>
                    Close
                  </a>
                  {teamid == "" && (
                    <a className="btn btn-success" onClick={submitpoints}>
                      Add
                    </a>
                  )}

                  {teamid != "" && (
                    <a className="btn btn-success" onClick={submitpoints}>
                      Update
                    </a>
                  )}
                </Modal.Footer>
              </Modal>
              {/* <Modal show={show} size="lg" onHide={handleclose}>
                <Modal.Header>
                  {teamid == "" && <h4> Add Leaderboard</h4>}
                  {teamid != "" && <h4> Leaderboard Details</h4>}
                </Modal.Header>
                <Modal.Body>
                  <Row className="row-sm mx-0">
                    <Col lg={6} md={6}>
                      <div className="form-group">
                        <label className="mb-2">
                          Team House Name <span className="errortext"> *</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Team House Name"
                          className="form-control"
                          value={hname}
                          onChange={(e) => setHName(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col lg={6} md={6}>
                      <div className="form-group">
                        <label className="mb-2">
                          Cricket Points
                        </label>
                        <input
                          type="text"
                          placeholder="Cricket Points"
                          className="form-control"
                          value={csport}
                          onChange={handleCricket}
                        />
                      </div>
                    </Col>

                    <Col lg={6} md={6}>
                      <div className="form-group">
                        <label className="mb-2">
                          Tennis Points
                        </label>
                        <input
                          type="text"
                          placeholder="Tennis Points"
                          className="form-control"
                          value={tsport}
                          onChange={handleTennis}
                        />
                      </div>
                    </Col>
                    <Col lg={6} md={6}>
                      <div className="form-group">
                        <label className="mb-2">
                          Football Points
                        </label>
                        <input
                          type="text"
                          placeholder="Football Points"
                          className="form-control"
                          value={fsport}
                          onChange={handleFootball}
                        />
                      </div>
                    </Col>
                    {id != 345 && (
                      <Col lg={6} md={6}>
                        <div className="form-group">
                          <label className="mb-2">
                            Badminton Points
                          </label>
                          <input
                            type="text"
                            placeholder="Badminton Points"
                            className="form-control"
                            value={bsport}
                            onChange={handleBadminton}
                          />
                        </div>
                      </Col>
                    )}

                    {(id == 265 || id == 324) && (
                      <Col lg={6} md={6}>
                        <div className="form-group">
                          <label className="mb-2">
                            Volleyball Points
                          </label>
                          <input
                            type="text"
                            placeholder="Volleyball Points"
                            className="form-control"
                            value={vsport}
                            onChange={handleVolley}
                          />
                        </div>
                      </Col>
                    )}
                    {id == 265 && (
                      <Col lg={6} md={6}>
                        <div className="form-group">
                          <label className="mb-2">
                            Tug of war Points
                          </label>
                          <input
                            type="text"
                            placeholder="Tug of war Points"
                            className="form-control"
                            value={twsport}
                            onChange={handleTugofwar}
                          />
                        </div>
                      </Col>
                    )}

                    {id != 265 && id != 324 && (
                      <>
                        <Col lg={6} md={6}>
                          <div className="form-group">
                            <label className="mb-2">Athletics Points</label>
                            <input
                              type="text"
                              placeholder="Athletics Points"
                              className="form-control"
                              value={asport}
                              onChange={handleAthletics}
                            />
                          </div>
                        </Col>
                        {id != 345 && (
                          <Col lg={6} md={6}>
                            <div className="form-group">
                              <label className="mb-2">Basketball Points</label>
                              <input
                                type="text"
                                placeholder="Basketball Points"
                                className="form-control"
                                value={bksport}
                                onChange={handleBasketball}
                              />
                            </div>
                          </Col>
                        )}
                      </>
                    )}
                    {id == 324 && (
                      <Col lg={6} md={6}>
                        <div className="form-group">
                          <label className="mb-2">Table Tennis Points</label>
                          <input
                            type="text"
                            placeholder="Table Tennis Points"
                            className="form-control"
                            value={ttsport}
                            onChange={handleTable}
                          />
                        </div>
                      </Col>
                    )}

                    {id == 345 && (
                      <Col lg={6} md={6}>
                        <div className="form-group">
                          <label className="mb-2">
                            Lagori Points
                          </label>
                          <input
                            type="text"
                            placeholder="Lagori Points"
                            className="form-control"
                            value={lsport}
                            onChange={handleLagori}
                          />
                        </div>
                      </Col>
                    )}
                  
                  </Row>
                  {errorMsg !== "" && (
                    <span className="errortext">{errorMsg}</span>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <a className="btn btn-danger" onClick={handleclose}>
                    Close
                  </a>
                  {teamid == "" && (
                    <a className="btn btn-success" onClick={submithigh}>
                      Add
                    </a>
                  )}

                  {teamid != "" && (
                    <a className="btn btn-success" onClick={submithigh}>
                      Update
                    </a>
                  )}
                </Modal.Footer>
              </Modal> */}

              <div className="table-responsive">
                {(localStorage.getItem("Role") === "1" ||
                  localStorage.getItem("Role") === "7") && (
                  <table className="sp-league-table sp-data-table">
                    <thead className="sp-table-header">
                      <tr role="row">
                        <th className="text-center">Team</th>
                        {sportsOptions.map((sport, idx) => (
                          <th className="text-center" key={idx}>
                            {sport.sports_name}
                          </th>
                        ))}
                        <th className="text-center">Total</th>
                        <th className="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filterProduct.map((item, j) => {
                        const getRowColor = () => {
                          return j % 2 === 0 ? "even" : "odd";
                        };
                        return (
                          <>
                            <tr
                              className={`sp-row-no-0 ${getRowColor()}`}
                              role="row"
                              key={j}
                            >
                              <td className="data-pct">{item.team_name}</td>
                              {sportsOptions.map((sport, idx) => (
                                <td key={idx} className="data-pct">
                                  {item[sport.sports_id] || 0}
                                </td>
                              ))}
                              <td className="data-pct">{item.total}</td>
                              <td className="data-pct">
                                <a
                                  onClick={() => highedit(item.team_id, item)}
                                  title="Edit Leaderboard"
                                  className="btn-sm btn-secondary me-2"
                                >
                                  <i className="fa fa-edit fa-lg"></i>
                                </a>
                                {localStorage.getItem("Role") === "1" && (
                                  <a
                                    onClick={() =>
                                      highdelete(item.team_id, item)
                                    }
                                    title="Edit Leaderboard"
                                    className="btn-sm btn-danger me-2"
                                  >
                                    <i className="fa fa-trash fa-lg"></i>
                                  </a>
                                )}
                              </td>
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                  // <table className="sp-league-table sp-data-table">
                  //   <thead className="sp-table-header">
                  //     <tr role="row">
                  //       <th className="text-center">Team</th>
                  //       <th className="text-center">Cricket</th>
                  //       <th className="text-center">Football</th>
                  //       {id != 345 && (
                  //         <th className="text-center">Badminton</th>
                  //       )}
                  //       {id == 265 && (
                  //         <>
                  //           <th className="text-center">Volleyball</th>
                  //           <th className="text-center">Tug of war</th>
                  //         </>
                  //       )}
                  //       {id != 265 && id != 324 && (
                  //         <>
                  //           <th className="text-center">Athletics</th>
                  //           {id != 345 && (
                  //             <>
                  //               <th className="text-center">Table Tennis</th>
                  //               <th className="text-center">Basketball</th>
                  //             </>
                  //           )}
                  //         </>
                  //       )}
                  //       {id == 324 && (
                  //         <>
                  //           <th className="text-center">Volleyball</th>
                  //           <th className="text-center">Table Tennis</th>
                  //         </>
                  //       )}
                  //       {id == 345 && <th className="text-center">Lagori</th>}
                  //       <th className="text-center">Total</th>
                  //       <th className="text-center">Action</th>
                  //     </tr>
                  //   </thead>
                  //   <tbody>
                  //     {filterProduct.map((item, j) => {
                  //       const getRowColor = () => {
                  //         return j % 2 === 0 ? "even" : "odd";
                  //       };
                  //       return (
                  //         <>
                  //           <tr
                  //             className={`sp-row-no-0 ${getRowColor()}`}
                  //             role="row"
                  //             key={j}
                  //           >
                  //             <td className="data-pct">
                  //               {item.team_house_name}
                  //             </td>
                  //             <td className="data-pct">{item.cricket}</td>
                  //             <td className="data-pct">{item.football}</td>
                  //             {id != 345 && (
                  //               <td className="data-pct">{item.badminton}</td>
                  //             )}
                  //             {id == 265 && (
                  //               <>
                  //                 <td className="data-pct">
                  //                   {item.volleyball}
                  //                 </td>
                  //                 <td className="data-pct">
                  //                   {item.tug_of_war}
                  //                 </td>
                  //               </>
                  //             )}
                  //             {/* <td className="data-pct">{item.tennis}</td> */}
                  //             {id != 265 && id != 324 && (
                  //               <>
                  //                 <td className="data-pct">{item.athletics}</td>

                  //                 {id != 345 && (
                  //                   <>
                  //                     <td className="data-pct">
                  //                       {item.table_tennis}
                  //                     </td>
                  //                     <td className="data-pct">
                  //                       {item.basket_ball}
                  //                     </td>
                  //                   </>
                  //                 )}
                  //               </>
                  //             )}
                  //             {id == 324 && (
                  //               <>
                  //                 <td className="data-pct">
                  //                   {item.volleyball}
                  //                 </td>
                  //                 <td className="data-pct">
                  //                   {item.table_tennis}
                  //                 </td>
                  //               </>
                  //             )}
                  //             {id == 345 && (
                  //               <td className="data-pct">{item.lagori}</td>
                  //             )}
                  //             <td className="data-pct">{item.total}</td>
                  //             <td className="data-pct">
                  //               <a
                  //                 onClick={() => highedit(item.id)}
                  //                 title="Edit Leaderboard"
                  //                 className="btn-sm btn-secondary me-2"
                  //               >
                  //                 <i className="fa fa-edit fa-lg"></i>
                  //               </a>
                  //               {localStorage.getItem("Role") === "1" && (
                  //                 <a
                  //                   onClick={() => highdelete(item.id, item)}
                  //                   title="Edit Leaderboard"
                  //                   className="btn-sm btn-danger me-2"
                  //                 >
                  //                   <i className="fa fa-trash fa-lg"></i>
                  //                 </a>
                  //               )}
                  //             </td>
                  //           </tr>
                  //         </>
                  //       );
                  //     })}
                  //   </tbody>
                  // </table>
                )}

                {(localStorage.getItem("Role") === "3" ||
                  localStorage.getItem("Role") === "4" ||
                  localStorage.getItem("Role") === "5" ||
                  localStorage.getItem("Role") === "6") && (
                  <table className="sp-league-table sp-data-table">
                    <thead className="sp-table-header">
                      <tr role="row">
                        <th className="text-center">Team</th>
                        {sportsOptions.map((sport, idx) => (
                          <th className="text-center" key={idx}>
                            {sport}
                          </th>
                        ))}
                        <th className="text-center">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filterProduct.map((item, j) => {
                        const getRowColor = () => {
                          return j % 2 === 0 ? "even" : "odd";
                        };
                        return (
                          <>
                            <tr
                              className={`sp-row-no-0 ${getRowColor()}`}
                              role="row"
                              key={j}
                            >
                              <td className="data-pct">{item.team_name}</td>
                              {sportsOptions.map((sport, idx) => (
                                <td key={idx} className="data-pct">
                                  {item[sport.sports_id] || 0}
                                </td>
                              ))}

                              <td className="data-pct">{item.total}</td>
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                  // <table className="sp-league-table sp-data-table">
                  //   <thead className="sp-table-header">
                  //     <tr role="row">
                  //       <th className="text-center">Team</th>
                  //       <th className="text-center">Cricket</th>
                  //       {/* <th className="text-center">Tennis</th> */}
                  //       <th className="text-center">Athletics</th>
                  //       <th className="text-center">Badminton</th>
                  //       <th className="text-center">Football</th>
                  //       <th className="text-center">Table Tennis</th>
                  //       <th className="text-center">Basketball</th>
                  //       <th className="text-center">Total</th>
                  //     </tr>
                  //   </thead>
                  //   <tbody>
                  //     {filterProduct.map((item, j) => {
                  //       const getRowColor = () => {
                  //         return j % 2 === 0 ? "even" : "odd";
                  //       };
                  //       return (
                  //         <>
                  //           <tr
                  //             className={`sp-row-no-0 ${getRowColor()}`}
                  //             role="row"
                  //             key={j}
                  //           >
                  //             <td className="data-pct">
                  //               {item.team_house_name}
                  //             </td>
                  //             <td className="data-pct">{item.cricket}</td>
                  //             {/* <td className="data-pct">{item.tennis}</td> */}
                  //             <td className="data-pct">{item.athletics}</td>
                  //             <td className="data-pct">{item.badminton}</td>
                  //             <td className="data-pct">{item.football}</td>
                  //             <td className="data-pct">{item.table_tennis}</td>
                  //             <td className="data-pct">{item.basket_ball}</td>

                  //             <td className="data-pct">{item.total}</td>
                  //           </tr>
                  //         </>
                  //       );
                  //     })}
                  //   </tbody>
                  // </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
